import { ArmyListSize } from '@Models';

export const computeMaxWithArmyListSize = (
  max: number,
  armyListSize: ArmyListSize,
): number => {
  if (armyListSize === ArmyListSize.Warbands) {
    return Math.ceil(max / 2);
  }

  if (armyListSize === ArmyListSize.GrandArmies) {
    return Math.ceil(max * 2);
  }

  return max;
};
